import { Component } from '@angular/core';
import { HelpService } from './help.service';

@Component({
  selector: 'app-help-button',
  template: `
    <button mat-icon-button class="help-toolbar-btn" (click)="openHelp()" matTooltip="Help Center" matTooltipPosition="below">
      <mat-icon>help_outline</mat-icon>
    </button>
  `,
  styles: [`
    :host {
      display: inline-flex;
      align-items: center;
    }

    .help-toolbar-btn {
      width: 42px;
      height: 42px;
      border-radius: 12px !important;
      background: color-mix(in srgb, var(--theme-on-surface) 5%, transparent);
      transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      color: var(--theme-on-surface);
    }

    .help-toolbar-btn:hover {
      background: color-mix(in srgb, var(--theme-primary) 15%, transparent);
      color: var(--theme-primary);
      transform: scale(1.05);
    }

    .help-toolbar-btn mat-icon {
      font-size: 22px;
      width: 22px;
      height: 22px;
    }
  `]
})
export class HelpButtonComponent {
  constructor(private helpService: HelpService) {}

  openHelp(): void {
    this.helpService.openDrawer();
  }
}
